import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare interface Event {
  evento: '';
  id: null;
  row: null;
}

declare interface Button {
  action: string;
  icon: string;
  color: string;
  enabled: boolean;
  type: string;
}

declare const $: any;

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  @Input() new_button: string = 'New';
  @Input() id: string = 'index';
  @Input() actions: boolean = true;
  @Input() print: boolean = false;
  @Input() create: boolean = true;
  @Input() show: boolean = true;
  @Input() delete: boolean = true;
  @Input() active: boolean = false;

  @Input() paginate: boolean = true;

  @Input() buttons: Button[] = [];

  @Input() dataTable: DataTable;

  @Output() out: EventEmitter<Event>;

  constructor() {
    this.out = new EventEmitter;
  }

  action(e) {
    this.out.emit(e);
  }

  saveEmit(accion, id = null, row = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      row: row
    };
    this.out.emit(send);
  }

  ngOnInit() {
    console.log(this.dataTable);
    if (this.actions && this.buttons.length === 0) {
      this.buttons = [
        {
          action: 'print',
          icon: 'print',
          color: 'btn-primary',
          enabled: this.print,
          type: 'just-icon'
        },
        {
          action: 'show',
          icon: 'remove_red_eye',
          color: 'btn-info',
          enabled: this.show,
          type: 'just-icon'
        },
        {
          action: 'delete',
          icon: 'clear',
          color: 'btn-danger',
          enabled: this.delete,
          type: 'just-icon'
        },
        {
          action: 'active',
          icon: 'power_settings_new',
          color: 'btn-dark',
          enabled: this.active,
          type: 'just-icon'
        }
      ];
    }
  }

}
